/* eslint-disable no-irregular-whitespace */
/**
 * 全局api变量
 * 一定要加上注释
 */

// 通用
export const WEB_VIDEO = 'wechat/course/web_video' // 获取视频



// WEBPACK FOOTER //
// ./src/api/global.js